import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import { Breadcrumbs } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-dashboard';

type Props = {
  subpageName?: string;
};

const AccountBreadcrumbs = ({ subpageName }: Props) => {
  const { thirdPartySlug } = useParams();
  const home = `/o/${thirdPartySlug}/admin`;
  const account = `${home}/account`;

  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href={home}>{_t('Home')}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={subpageName && account}>{_t('Account & Billing')}</Breadcrumbs.Item>
      {subpageName && <Breadcrumbs.Item>{subpageName}</Breadcrumbs.Item>}
    </Breadcrumbs>
  );
};

export default AccountBreadcrumbs;
